import React from 'react'

import Menu from '../Menu'
import AppNavigation, { NavigationProvider, useNavigation } from '../Navigation'
import { Shell } from '../Navigation/styles'

import { UpdateButton } from './styles'
import { withNamespaces } from 'react-i18next'

/** Menu de navegação (lateral, gaveta ou barra inferior) e, ao lado, a barra colorida e a página. */
const Layout = ({ children, t }) => {
  const { mode } = useNavigation()
  return (
    <div id="outer-container">
      <Shell mode={mode}>
        <AppNavigation />
        <div className="ps-main">
          <Menu />
          <section className="section-container" id="page-wrap-container">
            {children}
          </section>
        </div>
      </Shell>
      <UpdateButton pointer attention primary>
        {t('common.newVersion')}
      </UpdateButton>
    </div>
  )
}

const Base = (props) => (
  <NavigationProvider>
    <Layout {...props} />
  </NavigationProvider>
)

export default withNamespaces()(Base)
